<template>
  <Information />
</template>
<script setup>
import Information from '@/components/blocks/Information.vue'
</script>